import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-administrator-footer',
  templateUrl: './administrator-footer.component.html',
  styleUrls: ['./administrator-footer.component.css']
})
export class AdministratorFooterComponent implements OnInit {
  
  currentYear:any;

  constructor() { }

  ngOnInit() {
    this.currentYear= new Date().getFullYear();
  }

}
